import { Molecule, wrap } from 'AppReact';
import styled, { css } from 'styled-components';
import { Text } from 'atoms';
import { GreenTickSvg, HomeSvg } from 'components/icons';
import { IconFromUrl, Icon } from 'atoms';
import { Mx2, FlexCenterWrapper } from 'wrappers';

const template = styled.div`
  ${({ theme, displayState }) => css`
    color: ${window?.settings?.secondary_color ?? '#04333b'};
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    padding: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;

    background: ${displayState?.isSelected ? `${theme?.colour?.primary}0D` ?? "#1DBD6B0D" : ''};

    &:hover {
      background: ${`${theme?.colour?.primary}0D` ?? "#1DBD6B0D"};
    }
  `}
`

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      wrapper: FlexCenterWrapper,
      name: 'LeftSideWrapper',
      atoms: [
        {
          component: wrap(IconFromUrl, Mx2),
          name: 'Icon',
          renderIf: ({ icon }) => !!icon,
          displayValue: ({ icon }) => icon,
          displayState: ({ }) => ({ width: '16px', height: '16px' })
        },
        {
          component: Text,
          name: 'Name',
          displayValue: ({ name }) => name
        },
      ]
    },
    {
      component: Icon,
      name: 'Checkbox',
      renderIf: ({ isSelected }) => isSelected,
      displayValue: ({ }) => GreenTickSvg({}),
    },
  ]
})